/* eslint-disable no-restricted-imports */
/* eslint-disable functional/no-loop-statement */
import { newMostTitleSX } from '@/components/blocks/NewMost/styles/typography';
import { Grid, SxProps } from '@mui/material';
import { FC, useState, useEffect, useMemo, useRef } from 'react';
import { DpH2 } from '@/components/blocks/DpLibrary/DPText';
import { formattedCatalogEntryCarouselId } from 'integration/utils/formattedCatalogEntryCarouselId';
import { Linkable } from '../../../Linkable';
import {
	DpCatalogEntryCarouselHeaderButtonsFrameSX,
	DpCatalogEntryCarouselHeaderButtonSX,
} from '../style/main';
import { combineSX } from '@/utils/combineSX';

const hideInactiveElements = (ids: string[], activeId: string) => {
	ids.forEach((id) => {
		const element = document.getElementById(id);
		if (element) {
			if (id === activeId) {
				element.style.transition = 'opacity 0.5s ease-in';
				element.style.opacity = '1';
				element.style.display = 'grid';
			} else {
				element.style.transition = 'opacity 0.5s ease-out';
				element.style.opacity = '0';
				element.style.display = 'none';
			}
		}
	});
};

type Props = {
	title: string;
	href?: string;
	buttons?: { name: string; carouselId: string }[];
	titlesx?: SxProps;
};

export const DpCatalogEntryCarouselHeaderContent: FC<Props> = ({
	title,
	href,
	buttons,
	titlesx,
}) => {
	const [selected, setSelected] = useState<string>('');

	const ids = useMemo(
		() => buttons?.map((button) => formattedCatalogEntryCarouselId(button.carouselId)) || [],
		[buttons]
	);

	const handleSelected = (activeId: string) => {
		const _activeId = formattedCatalogEntryCarouselId(activeId);
		hideInactiveElements(ids, _activeId);
		setSelected(_activeId);
	};

	useEffect(() => {
		if (ids.length > 0) {
			hideInactiveElements(ids, ids[0]);
			setSelected(ids[0]);
		}
	}, [ids]);

	const buttonRefs = useRef<(HTMLDivElement | null)[]>([]);
	const [buttonWidths, setButtonWidths] = useState<number[]>([]);

	const calculateButtonWidths = () => {
		const widths = buttonRefs.current.map((ref) => {
			if (ref) {
				return ref.offsetWidth + 2;
			}
			return 0;
		});

		setButtonWidths(widths);
	};

	useEffect(() => {
		if (buttons && buttons.length > 0) {
			calculateButtonWidths();
		}
	}, [buttons]);

	return (
		<Grid
			sx={{
				display: 'flex',
				flexDirection: {
					xs: 'column',
					sm: 'row',
				},
				gap: '10px',
				alignItems: {
					sm: 'center',
				},
				mb: { xs: buttons && buttons?.length > 0 ? '10px' : '20px', sm: '20px' },
			}}
		>
			<DpH2
				sx={combineSX([newMostTitleSX(!!href), ...(Array.isArray(titlesx) ? titlesx : [titlesx])])}
			>
				<Linkable href={href}>{title}</Linkable>
			</DpH2>
			{buttons && buttons?.length > 0 ? (
				<Grid sx={DpCatalogEntryCarouselHeaderButtonsFrameSX}>
					{buttons.map((button, index: number) => {
						const active = selected === formattedCatalogEntryCarouselId(button.carouselId);
						return (
							<Grid
								key={`id_top_button_${index}`}
								ref={(el: HTMLDivElement | null) => (buttonRefs.current[index] = el)}
								sx={combineSX([
									DpCatalogEntryCarouselHeaderButtonSX(active),
									{ width: buttonWidths[index] || 'auto' },
								])}
								onClick={() => handleSelected(button.carouselId)}
							>
								{button.name}
							</Grid>
						);
					})}
				</Grid>
			) : null}
		</Grid>
	);
};
